import React from 'react';

const CheckvronUpIcon = () => {
  return (
    <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M4.53662 16.3633L12.012 8.88787L19.4874 16.3633" stroke="#08081B" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>

  )
}

export default CheckvronUpIcon;